module.exports = __webpack_public_path__ + "cbd95957781f73a837a6333aa980a253.svg";